import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_8: FaireProductEntity = {
  token: "atc_fs_8",
  type: "product",
  name: "Flyaway Taming Hair Wax Stick",
  brandName: "Kitsch",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b37ae138097bafe7c721eaa9705eb1cec9aff99037d9d4a1e7c63257821be6a4.webp",
  priceDollars: 14,
  msrpDollars: 28,
  description: "ATC migration seed product",
  tags: ["beauty", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
